export default __webpack_public_path__ + "static/media/Mail Room- Mail 3.aa85b2a7.jpg";